module.exports = __webpack_public_path__ + "static/media/1021441.94b2d577.jpg";